module.exports = __webpack_public_path__ + "static/media/cockroach(15).e7b6b1ad.PNG";